import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import ToastContext from '../contexts/ToastContext';
import { supabase } from '../supabase';

export default function ForgotPassword() {
  const emailRef = useRef();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const toast = useContext(ToastContext);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      if (!supabase) throw new Error('Supabase is not configured');
      const { error: resetError } = await supabase.auth.resetPasswordForEmail(emailRef.current.value, {
        redirectTo: `${window.location.origin}/reset-password`
      });
      if (resetError) throw resetError;
      setSubmitted(true);
      if (toast && toast.success) toast.success('Email envoyé avec succès');
    } catch (err) {
      const friendly = err?.message || 'Erreur inconnue';
      setError(friendly);
      if (toast && toast.error) toast.error(friendly);
    }
    setLoading(false);
  }

  if (submitted) {
    return (
      <div className="container">
        <div className="card" style={{maxWidth:480,margin:'1rem auto'}}>
          <h2>Email envoyé</h2>
          
          <div style={{
            background: 'rgba(76, 175, 80, 0.04)',
            border: '1px solid #4CAF50',
            borderRadius: '8px',
            padding: '20px',
            marginBottom: '20px'
          }}>
            <p style={{color: '#2e7d32', marginBottom: '10px'}}>
              ✓ Un email de réinitialisation a été envoyé à votre adresse email.
            </p>
            <p style={{color: '#666', fontSize: '0.9rem', marginBottom: '0'}}>
              Veuillez vérifier votre boîte de réception (y compris le dossier indésirables) et suivez les instructions pour réinitialiser votre mot de passe.
            </p>
          </div>

          <p style={{textAlign: 'center', marginBottom: '20px'}}>
            Vous avez déjà reçu un email de réinitialisation?
          </p>
          
          <div style={{display: 'flex', gap: '10px'}}>
            <Link to="/login" className="btn btn-primary" style={{flex: 1, textAlign: 'center', textDecoration: 'none'}}>
              Retour à la connexion
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="card" style={{maxWidth:480,margin:'1rem auto'}}>
        <h2>Mot de passe oublié</h2>
        <p style={{color: '#666', marginBottom: '20px'}}>
          Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.
        </p>

        {error && (
          <div role="alert" className="card headerless" style={{background:'rgba(239,68,68,0.04)',borderLeft:'4px solid var(--danger)',marginBottom:'12px'}}>
            <div style={{color:'var(--danger)'}}>{error}</div>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="field">
            <label className="muted">Email</label>
            <input className="input" type="email" ref={emailRef} required aria-required="true" placeholder="votre@email.com" />
          </div>

          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginTop:20, gap: '10px'}}>
            <Link to="/login" style={{color:'var(--primary)',textDecoration:'none',fontSize:'0.9rem'}}>
              Retour à la connexion
            </Link>
            <button className="btn btn-primary" disabled={loading} type="submit">
              {loading ? 'Envoi...' : 'Envoyer le lien'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
